<template>
  <div>
    <el-steps :active="active" align-center finish-status="success">
      <el-step title="Selecionar colunas"></el-step>
      <el-step title="Importar"></el-step>
    </el-steps>

    <el-card shadow="always">
      <div>
        <el-form
          ref="form"
          :model="importForm"
          label-width="120px"
          v-if="active === 0"
        >
          <el-row :gutter="5">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
              <el-form-item :label="$t('usar')" prop="use">
                <el-select
                  ref="user"
                  v-model="importForm.use"
                  placeholder="Selecione  uma opção"
                >
                  <el-option key="1" label="Separador" value="1"></el-option>
                  <el-option key="2" label="Tamanho Fixo" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
              <el-form-item :label="$t('meus-layouts')" prop="layout">
                <el-select
                  ref="user"
                  v-model="importForm.use"
                  placeholder="Selecione  uma opção"
                >
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <br />
        <el-upload
          v-if="active === 1"
          class="upload-demo"
          drag
          action="/api/import/upload/"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Arraste o arquivo ou <em>clique para aqui para enviar</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            Arquivos csv/txt com a listagem de pre-postagens
          </div>
        </el-upload>

        <el-transfer
          v-if="active === 0"
          filterable
          :filter-method="filterMethod"
          filter-placeholder="Campos"
          v-model="value"
          :titles="['Disponiveis', 'Selecionados']"
          :data="tableData"
        >
          <el-button
            class="transfer-footer"
            slot="right-footer"
            size="small"
            type="warning"
            @click="save()"
            >Salvar Layout</el-button
          >
        </el-transfer>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="4" :offset="16">
            <el-button v-if="active > 0" @click="back()">Voltar</el-button>
            <el-button v-if="active < 1" type="primary" @click="next()"
              >Prosseguir</el-button
            >
            <el-button v-if="active == 1" type="warning" @click="finish()"
              >Finalizar</el-button
            >
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="active === 0">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-table size="mini" :data="tableData" style="width: 100%">
              <el-table-column prop="label"></el-table-column>
              <el-table-column prop="description"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import DepartmentList from "@/xpost/views/register/department/DepartmentList.vue";
import { UserService } from "@/services/users/user.services";
import { LayoutService } from "@/services/customers/layout.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "ImportPrepost",
  props: ["state"],
  components: {
    DepartmentList,
  },
  props: ["type"],
  methods: {
    save() {
      const vm = this;
      if (vm.value.length == 0) {
        this.$message({
          type: "error",
          message: "Selecione ao menos um campo para salvar o layout",
        });
        return false;
      }
      this.$prompt("Informe um nome para o layout", "Salvar", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        inputPlaceholder: "Informe um nome",
        inputErrorMessage: "É obrigatório informar um nome",
        inputValidator: function (v) {
          if (!v) {
            return false;
          }
        },
      })
        .then(({ value }) => {
          const data = {
            name: value,
            fields: vm.value,
            type: vm.$props.type,
          };
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          LayoutService.add(data)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("layout-salvo-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        })
        .catch(() => {});
    },
    next() {
      const vm = this;
      vm.active++;
    },
    back() {
      const vm = this;
      vm.active--;
    },
  },
  data() {
    return {
      importForm: {
        use: "",
        department: "",
      },
      filterMethod(query, item) {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      },
      active: 0,
      value: [],
      customer: "",
      tableData: [
        {
          label: "CODIGO",
          key: "CODIGO",
          description: "CÓDIGO DO REMETENTE",
        },
        {
          label: "CPF_CNPJ",
          key: "CPF_CNPJ",
          description: "CPF/CNPJ DO REMETENTE",
        },
        {
          label: "REMETENTE",
          key: "REMETENTE",
          description: "NOME DO REMETENTE",
        },
        {
          label: "EMPRESA",
          key: "EMPRESA",
          description: "EMPRESA RELACIONADA A ENTREGA AO REMETENTE",
        },
        { label: "CEP", key: "CEP", description: "CEP DO REMETENTE" },
        {
          label: "ENDERECO",
          key: "ENDERECO",
          description: "ENDEREÇO DO REMETENTE",
        },
        {
          label: "NUMERO",
          key: "NUMERO",
          description: "NÚMERO DO REMETENTE",
        },
        {
          label: "COMPLEMENTO",
          key: "COMPLEMENTO",
          description: "COMPLEMENTO DO ENDEREÇO DO REMETENTE",
        },
        {
          label: "BAIRRO",
          key: "BAIRRO",
          description: "BAIRRO DO REMETENTE",
        },
        {
          label: "CIDADE",
          key: "CIDADE",
          description: "CIDADE DO REMETENTE",
        },
        { label: "UF", key: "UF", description: "UF DO REMETENTE" },
        {
          label: "INF_ADICIONAL",
          key: "INF_ADICIONAL",
          description: "OBSERVAÇÃO RELACIONADA AO REMETENTE",
        },

        {
          label: "ESPAÇOS",
          key: "ESPAÇOS",
          description:
            "RELACIONADO A CAMPOS A SEREM DESCONSIDERADOS NA IMPORTAÇÃO",
        },
      ],
    };
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {})
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
